import { API_URL, GET_RMA_SHIPPING_LABEL_AS_IMAGE_URL } from "../AppConfig"
import { apiToken, getSessionToken } from "../redux/actions/orderAction";

export const getShippingLabelAsImage = async (pdfLabelUrl) => {
    let api_key= window.sessionStorage.getItem('storeClerkToken');
    if(!api_key) api_key= await apiToken()
    const sessionToken = await getSessionToken()
    
    const headers = new Headers();    
    headers.set('Content-Type', 'application/json');
    headers.set('api_key', api_key);  
    headers.set('moquiSessionToken', sessionToken);

    const response = await fetch(`${API_URL + GET_RMA_SHIPPING_LABEL_AS_IMAGE_URL}`,{ method:'POST', headers:headers, body: JSON.stringify({pdfLabelUrl}) })
    return await response.json();
}


// WEBPACK FOOTER //
// ./src/api/api.js